import { render, staticRenderFns } from "./PortfolioCompanies.vue?vue&type=template&id=589de9e0&scoped=true"
import script from "./PortfolioCompanies.vue?vue&type=script&lang=js"
export * from "./PortfolioCompanies.vue?vue&type=script&lang=js"
import style0 from "./PortfolioCompanies.vue?vue&type=style&index=0&id=589de9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589de9e0",
  null
  
)

export default component.exports